import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { effects } from './effects';
import * as fromStore from './reducers';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromStore.profilerFeatureKey, fromStore.reducers),
    EffectsModule.forFeature(effects)
  ]
})
export class AtlasProfilerStoreModule {}
